<template>
  <div class="port-search">
    <div v-if="selectedValue" class="selected-entity">
      <b-badge variant="success">
        <div :title="selectedValue" class="label">{{ selectedValue }}</div>
        <b-btn-close size="sm" @click="handleSearchResultRemoved"/>
      </b-badge>
    </div>

    <multiselect
      class="search-multiselect"
      :options="results"
      :multiple="true"
      :loading="searchLoading"
      track-by="value"
      label="text"
      selected-label=""
      :close-on-select="true"
      :internal-search="false"
      :limit="2"
      @search-change="handleSearchChange"
      @remove="handleSearchResultRemoved"
      @select="handleSearchResultSelected"
      @open="() => {this.searchOpened = true}"
      @close="() => {this.searchOpened = false}"
      :placeholder="title">

      <template #beforeList>
        <div class="dropdown-title">Ports / Berths</div>
      </template>

      <template #option="{option}">
        <div class="search-multiselect__option">
          <div class="d-flex flex-column">
            <div class="text-left text-value-sm">
              <strong>{{ option.entityType }}:</strong> {{ option.berthName || option.portName }}
            </div>
          </div>
          <div class="d-flex flex-column text-value-sm">
            <div>{{ option.unlocode }}</div>
          </div>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import debounce from 'lodash-es/debounce';
import getNested from 'lodash-es/get';
import { mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';

const algoliaBaseParameters = {
  'getRankingInfo': true,
  'analytics': false,
  'enableABTest': false,
  'hitsPerPage': 50,
  'attributesToRetrieve': '*',
  'attributesToSnippet': '*:20',
  'snippetEllipsisText': '…',
  'responseFields': '*',
  'page': 0,
  'facets': ['*'],
};

export default {
  name: 'port-search-widget',

  components: {
    Multiselect,
  },

  props: {
    title: {
      type: String,
      default: 'Port search',
    },

    searchResults: {
      type: Array,
      default: null,
    },

    searchValue: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      searchOpened: false,
      searchIndex: 'polygons_prod',
      searchLoading: false,
      results: this.searchResults || [],
      value: null,
    };
  },


  methods: {
    ...mapActions('api', ['algoliaSearch']),

    handleSearchChange: debounce(async function (searchString) {
      if(!this.searchOpened) {
        // multiselect sends empty searchString when dropdown has been closed,
        // we don't need this
        return;
      }

      this.searchLoading = true;
      const response = await this.algoliaSearch({
        searchIndex: this.searchIndex,
        query: searchString,
        searchParameters: algoliaBaseParameters,
      });

      this.results = getNested(response, 'hits', []).map(item => {
        let id = `${item.entity_type}-${item.berth_id || item.port_id}`.toLowerCase();

        return {
          id,
          value: id,
          text: item.berth_id ? item.berth_name : item.port_name,
          entityType: item.entity_type,
          berthId: item.berth_id,
          berthName: item.berth_name,
          portId: item.port_id,
          portName: item.port_name,
          unlocode: item.unlocode,
        };
      });
      this.searchLoading = false;
    }, 300),

    handleSearchResultSelected(selectedValue) {
      this.$nextTick(() => {
        this.value = selectedValue;
        this.$emit('input', this.searchData);
      });
    },

    handleSearchResultRemoved() {
      this.$nextTick(() => {
        this.value = null;
        this.$emit('input', this.searchData);
      });
    },
  },

  computed: {
    selectedValue() {
      if(!this.value) {
        return null;
      }

      // looks like it's better to display a port at the top row,
      // since it's possible to select a few berths, this case a selected berth looks ambigous
      const portName = getNested(this.value, 'portName', 'Unknown port');
      return `Port: ${portName}`;

      // if(this.value.entityType === 'PORT') {
      //   return `Port: ${this.value.portName}`;
      // } else if(this.value.entityType === 'BERTH') {
      //   return `Berth: ${this.value.berthName}`;
      // } else {
      //   return 'Unknown entity';
      // }
    },

    searchData() {
      return {
        value: this.value,
        results: this.results,
      };
    },
  },

  watch: {
    searchValue: {
      immediate: true,
      deep: true,
      handler: function (value) {
        this.value = value;
      }
    }
  },
}
</script>

<style scoped>
.search-multiselect {
  min-width: 250px;
  width: auto;
}

.search-multiselect.multiselect--active {
  min-width: 500px !important;
  transition: all 0.2s;
}
</style>

<style scoped lang="scss">
.port-search {
  //min-width: 300px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .search-multiselect {
    //margin-left: 20px;
  }

  .selected-entity {
    display: flex;
    align-items: center;
    //margin-right: auto;
    padding-right: 20px;

    .label {
      height: 16px;
      max-width: 250px;
      padding: 0 5px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .badge {
      display: flex;
      align-items: center;
      height: 32px;

      .close {
        padding: 0 3px;
        outline: none;
      }
    }
  }
}
</style>
